'use client'

import React, { ReactElement } from 'react'
import ChevronDownIcon from '@/icons/font-awesome/sharp-light/chevron-down.svg'
import { Select, SelectProps } from '@/components/hotel/Select'

export default function HotelSelect(props: SelectProps): ReactElement {
  const selectMonthName = props.options.find((o) => o.value === props.selectedValue)?.label
  const selectedYear = props.selectedYear ? ` ${props.selectedYear}` : ''
  const selectedValue = selectMonthName ? `${selectMonthName}${selectedYear}` : undefined

  return (
    <Select
      {...props}
      icon={
        <>
          {props.icon && <div className="h-4 w-4 fill-stone-400">{props.icon}</div>}
          <div className="grow">
            {props.label && (
              <div className="text-xxs leading-none text-stone-400">{props.label}</div>
            )}
            <input
              readOnly={true}
              value={selectedValue}
              className="m-0 w-full cursor-default appearance-none overflow-hidden rounded-md border-0 bg-none p-0 leading-none caret-transparent outline-none focus:ring-0 focus:ring-offset-0"
            />
          </div>
          <ChevronDownIcon className="h-4 w-4" />
        </>
      }
    />
  )
}
